/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { ClosedEnum } from "../../types/enums.js";

/**
 * The card brand.
 */
export const CardBrand = {
  AmericanExpress: "American Express",
  Discover: "Discover",
  Mastercard: "Mastercard",
  Visa: "Visa",
  Unknown: "Unknown",
} as const;
/**
 * The card brand.
 */
export type CardBrand = ClosedEnum<typeof CardBrand>;

/** @internal */
export const CardBrand$inboundSchema: z.ZodNativeEnum<typeof CardBrand> = z
  .nativeEnum(CardBrand);
/** @internal */
export const CardBrand$outboundSchema: z.ZodNativeEnum<typeof CardBrand> =
  CardBrand$inboundSchema;
